// extracted by mini-css-extract-plugin
export var container = "_5q-1";
export var cornerButtonContainer = "_5q-6";
export var disabled = "_5q-2";
export var dragActive = "_5q-3";
export var fileContainer = "_5q-5";
export var hiddenInput = "_5q-4";
export var widthContainer = "_5q-0";